import clsx from 'clsx'
import { useLayoutEffect, useRef, useState } from 'preact/hooks'
import useMeasure from 'use-measure'

import { MaxLabel } from './MaxLabel'
import { StepSliderProvider } from './Provider'
import { Thumb } from './Thumb'
import { Track } from './Track'

interface StepSliderProps {
  steps?: number
  className?: string
  children?: preact.ComponentChildren
}

export function StepSlider({ className, children, steps = 4 }: StepSliderProps) {
  const constraintRef = useRef<HTMLDivElement>(null)
  const thumbRef = useRef<HTMLDivElement>(null)
  const { width: constraintWidth } = useMeasure(constraintRef)
  const { width: thumbWidth } = useMeasure(thumbRef)
  const width = Math.max(Math.round(constraintWidth - thumbWidth), 1)
  const [trackLength, setTrackLength] = useState(width)

  useLayoutEffect(() => {
    setTrackLength(
      Math.max(Math.round((constraintRef.current?.clientWidth || 0) - (thumbRef.current?.clientWidth || 0)), 1),
    )
  }, [width])

  return (
    <StepSliderProvider steps={steps} constraintRef={constraintRef} thumbRef={thumbRef} trackLength={trackLength}>
      <div className={clsx('relative flex flex-col items-center w-full select-none', className)}>{children}</div>
    </StepSliderProvider>
  )
}

StepSlider.Thumb = Thumb
StepSlider.Track = Track
StepSlider.MaxLabel = MaxLabel
